// extracted by mini-css-extract-plugin
export var container = "_7z-0";